<template>
  <div>
    <p class="h1 text-bold mb-3 text-info" v-text="isCreate ? lang.create_user : lang.edit_user"></p>
    <b-form class="border p-2" @submit.prevent="onSubmit">
      <b-form-group
        id="fieldset-name"
        label-for="name"
        label-size="lg"
        label-class="font-weight-bold pb-0"
        class="required"
      >
      </b-form-group>

      <b-form-group
        id="fieldset-email"
        label-for="email"
        label-size="lg"
        label-class="font-weight-bold pb-0"
        class="required"
        description="Only pfizer emails are allowed"
      >
        <template slot="label">
          <span>{{ lang.email }}</span>
        </template>
        <b-form-input id="email" name="email" v-model.trim="form.email" type="email" placeholder="Pfizer email"/>
        <div v-if="hasError('email')">
          <div
            class="alert alert-danger mt-1"
            v-if="show_errors"
            v-text="lang.required_field_error"
          ></div>
        </div>
      </b-form-group>

      <b-form-group
        id="fieldset-role"
        label-for="role"
        label-size="lg"
        label-class="font-weight-bold pb-0"
        class="required"
      >
        <template slot="label">
          <span>{{ lang.role }}</span>
        </template>
        <b-form-select id="role" v-model="form.role_id">
          <option
            v-for="role in roles"
            :key="role.id"
            :value="role.id"
            v-text="role.name"
          ></option>
        </b-form-select>
        <div v-if="hasError('role_id')">
          <div
            class="alert alert-danger mt-1"
            v-if="show_errors"
            v-text="lang.required_field_error"
          ></div>
        </div>
      </b-form-group>

      <b-form-group>
        <b-button
          type="submit"
          variant="primary"
          v-text="isCreate ? lang.save : lang.update"
        ></b-button>
        <b-button variant="danger" v-text="lang.cancel" :href="cancelRoute"></b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    lang: Object,
    route: String,
    cancelRoute: String,
    currentUser: Object,
    roles: Array
  },
  data() {
    return {
      form: {
        name: null,
        email: null,
        role_id: null,
      },
      errors: {},
      show_errors: false,
      saving: false
    };
  },
  computed: {
    isCreate() {
      return !this.currentUser;
    }
  },
  created() {
    if (!this.isCreate) {
      this.form.name = this.currentUser.name;
      this.form.email = this.currentUser.email;
      this.form.role_id = this.currentUser.role_id;
    }
  },
  methods: {
    onSubmit() {
      this.show_errors = true;

      if (Object.keys(this.errors).length != 0) {
        this.$snotify.error("There are errors on the form");
        return;
      }

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    hasError(field) {
      if (!this.form[field] || this.form[field].length == 0) {
        this.errors[field] = true;
        return true;
      } else {
        delete this.errors[field];
        return false;
      }
    },
    create() {
      this.saving = true;
      axios
        .post(this.route, this.form)
        .then(response => {
          if (response.data.error) {
            this.$snotify.error(response.data.error.message);
            return;
          }
          this.saving = false;
          window.location.href = "/admin/users/" + response.data.data.id + '?state=created';
        })
        .catch(error => {
          this.saving = false;
          this.$snotify.error("Error Occurred");
        });
    },
    update() {
      this.saving = true;
      axios
        .patch(this.route, this.form)
        .then(response => {
          this.saving = false;
          window.location.href = "/admin/users/" + response.data.data.id + '?state=updated';
        })
        .catch(error => {
          this.saving = false;
          this.$snotify.error("Error Occurred");
        });
    }
  }
};
</script>

